import { useId, useRef, type FC } from "react";

import { type PropsWithClassName } from "@/components/podkit/lib/cn";

export const CLionLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.63626 9.39175L9.15491 0.0311279L14.5982 3.04827L8.63626 9.39175Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path
                d="M8.63626 9.39175L9.15491 0.0311279L2.24291 4.38728L0.0311699 17.6303L8.63626 9.39175Z"
                fill={`url(#paint1_linear_${id})`}
            />
            <path
                d="M23.4926 7.20504L20.4131 0.943848L14.5982 3.04837L8.63626 9.39185L0.0311699 17.6304L7.79346 23.2807L17.5505 14.4811L23.4926 7.20504Z"
                fill={`url(#paint2_linear_${id})`}
            />
            <path
                d="M19.4805 13.7554V19.4805H10.08L14.2117 22.6771L20.1962 23.9688L23.9688 15.4285L19.4805 13.7554Z"
                fill={`url(#paint3_linear_${id})`}
            />
            <path d="M4.51948 4.51953H19.4805V19.4806H4.51948V4.51953Z" fill="black" />
            <path d="M6.38462 16.6528H11.995V17.5879H6.38462V16.6528Z" fill="white" />
            <path d="M12.0125 6.37463H13.2592V10.9602H15.7153V12H12.0125V6.37463Z" fill="white" />
            <path
                d="M5.98566 9.22468V9.20972C5.97881 8.8215 6.0506 8.43591 6.1967 8.07617C6.3428 7.71643 6.5602 7.38998 6.8358 7.11647C7.1114 6.84297 7.43951 6.62807 7.80035 6.48472C8.1612 6.34137 8.54733 6.27253 8.93548 6.28235C9.34762 6.26204 9.75939 6.32932 10.1436 6.47975C10.5279 6.63018 10.8759 6.86035 11.1647 7.15507L10.3792 8.07019C9.99873 7.67563 9.47844 7.44638 8.93049 7.43185C7.97797 7.43185 7.29226 8.22229 7.29226 9.19227V9.20972C7.29226 10.1797 7.96301 10.9876 8.93049 10.9876C9.57881 10.9876 9.97278 10.7382 10.4266 10.3243L11.2046 11.1272C10.9183 11.4583 10.5606 11.72 10.1585 11.8928C9.75639 12.0656 9.32031 12.1448 8.88312 12.1246C8.50083 12.1304 8.12128 12.0592 7.76699 11.9155C7.41271 11.7718 7.0909 11.5583 6.82067 11.2879C6.55043 11.0174 6.33727 10.6954 6.19384 10.341C6.0504 9.98658 5.97961 9.60697 5.98566 9.22468Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="8.63626"
                    y1="4.71144"
                    x2="15.4934"
                    y2="4.71144"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF318C" />
                    <stop offset="0.15" stopColor="#FB348C" />
                    <stop offset="0.28" stopColor="#F03C8C" />
                    <stop offset="0.42" stopColor="#DE4A8C" />
                    <stop offset="0.54" stopColor="#C45D8B" />
                    <stop offset="0.67" stopColor="#A2778B" />
                    <stop offset="0.79" stopColor="#79958A" />
                    <stop offset="0.91" stopColor="#49B98A" />
                    <stop offset="1" stopColor="#21D789" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="5.88842"
                    y1="3.06822"
                    x2="2.36759"
                    y2="26.6917"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.09" stopColor="#21D789" />
                    <stop offset="0.9" stopColor="#009AE5" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="21.8618"
                    y1="2.25045"
                    x2="-2.22046"
                    y2="27.6842"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.09" stopColor="#21D789" />
                    <stop offset="0.9" stopColor="#009AE5" />
                </linearGradient>
                <linearGradient
                    id={`paint3_linear_${id}`}
                    x1="14.5783"
                    y1="18.114"
                    x2="22.8143"
                    y2="19.286"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.09" stopColor="#21D789" />
                    <stop offset="0.9" stopColor="#009AE5" />
                </linearGradient>
            </defs>
        </svg>
    );
};
